import '../../../App.css';
import { useAppSelector } from '../../../store/hooks';
import { RootState } from "../../../store/store";

interface ToolbarButtonProps {
    onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    icon: '.png';
    tooltip: string;
    toolname: string;
}

const ToolbarButton = ({ onClick, icon, tooltip, toolname }: ToolbarButtonProps) => {
    const activeTool = useAppSelector((state: RootState) => state.tool.currentTool);

    return (
        <button
            onClick={onClick}
            className={toolname === activeTool ? "toolbar__button--active" : "toolbar__button"}
        >
            <img src={icon} alt={tooltip} />
        </button>
    )
}
export default ToolbarButton;
